import React from 'react';
import { Helmet } from 'react-helmet-async';
import { META } from '../../../../constants';
import Error from '../Error';

const PageNotFound = () => (
    <>
        <Helmet>
            <title>{META.notFoundPageTitle}</title>
        </Helmet>
        <Error pageNotFound />
    </>
);

export default PageNotFound;
